export const QUICK_ACTION_HOTKEYS = {
	createChild: { display: '⇧ C', key: 'C' },
	linkIssue: { display: '⇧ K', key: 'K' },
};
